import React from 'react';
import { clsx } from 'clsx';
import { Icon } from '@/ui/icons/Icon';
import styles from './InstallmentRepaymentDetails.module.scss';
import { format } from 'date-fns';
import { Button } from '@/ui/components';

export interface InstallmentRepaymentDetailsProps {
  lastPaymentDate: Date | undefined;
  bankCard: string;
  className?: string;
  showEditIcons?: boolean;
  onEditBankCard?: () => void;
  // Shown with a card: picks another card the money is paid to.
  onChangeBankCard?: () => void;
}

export const InstallmentRepaymentDetails: React.FC<
  InstallmentRepaymentDetailsProps
> = ({
  lastPaymentDate,
  bankCard,
  className,
  showEditIcons = false,
  onEditBankCard,
  onChangeBankCard,
}) => {
  return (
    <div className={clsx(styles.repaymentDetailsSection, className)}>
      <div className={styles.sectionHeader}>
        <h3 className={styles.sectionTitle}>Detalii rambursare</h3>
      </div>

      <div className={styles.repaymentCard}>
        {/* Last Payment Date */}
        {lastPaymentDate && (
          <div className={styles.detailRow}>
            <div className={styles.detailLeft}>
              <p className={styles.detailLabel}>Data ultimei rate</p>
            </div>
            <div className={styles.detailRight}>
              <span className={styles.detailValue}>
                {format(lastPaymentDate, 'dd.MM.yyyy')}
              </span>
            </div>
          </div>
        )}

        {/* Bank Card */}
        <div className={styles.detailRow}>
          <div className={styles.detailLeft}>
            <p className={styles.detailLabel}>Card bancar</p>
          </div>
          <div className={styles.detailRight}>
            <div className={styles.cardInfo}>
              <span className={styles.detailValue}>{bankCard}</span>
              {!showEditIcons && onChangeBankCard && (
                <Button
                  trackingId="change_bank_card_installment_repayment_details"
                  className={styles.editButton}
                  variant="text"
                  size="xsmall"
                  iconOnly
                  aria-label="Schimbă cardul"
                  leftIcon={<Icon name="pen" className={styles.editIcon} />}
                  onClick={onChangeBankCard}
                />
              )}
              {showEditIcons && (
                <Button
                  trackingId="add_bank_card_installment_repayment_details"
                  className={styles.addBankCardButton}
                  variant="text"
                  rightIcon={<Icon name="plus" className={styles.editIcon} />}
                  onClick={onEditBankCard}
                  text="Adaugă"
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
